import { PdSteps } from "./PdSteps.js";
//#region src/pd-wizard/pd-steps/pd-steps.ts
var tag = "pd-steps";
if (!customElements.get(tag)) customElements.define(tag, PdSteps);
//#endregion
export { PdSteps };
